module.exports = __webpack_public_path__ + "static/img/verify.5606e88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/verify.jpg
// module id = OIr+
// module chunks = 0